import type { TGetLotesEmpreendimentoResponse } from '@/features/produtos/interfaces/produto.types'
import { HttpService } from '@/shared/lib/http'

export class GetLotesEmpreendimentoService extends HttpService {
  execute = async (idExternoEmpreendimento: string) => {
    return this.http.get<TGetLotesEmpreendimentoResponse>(
      `/api/v2/Produto/empreendimento/${idExternoEmpreendimento}/lotes`,
    )
  }
}
